import React from "react";
import { Button } from "../../../../../../../../shared/Button/Button";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { CheckIcon } from "../../../../../../../../assets/Icons/CheckIcon";
import styles from "./styles.module.scss";
import { useContext } from "../../../../context";
import { uiNotification } from "../../../../../../../../services/UINotificationService";

export const Footer = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey.preview",
  });

  const { previewAnswers, blocks } = useContext();
  const current = blocks.getCurrent();

  const handleClick = () => {
    if (
      blocks.isRequired(current.id) &&
      !previewAnswers.isAnswered(current.id)
    ) {
      uiNotification.error(t("error.questionRequired"));
    } else {
      blocks.focusNextBlock();
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      className={styles.root}
      rightAdornment={<CheckIcon />}
      onClick={handleClick}
    >
      {t("ok")}
    </Button>
  );
};
